fragment parashahDetails on ParashahType {
  reading {
    id
  }
  order
  section
  transliteratedTitle
  heTitle
}
